export default __webpack_public_path__ + "static/media/kenya.bf0d0a95.png";